import React from 'react';

const GiftCardsTable = ({ giftCards, selectedItems, handleCheckboxChange, formatTime }) => (
  <>
    <h3 className="text-2xl font-extrabold text-emerald-400 mt-10 mb-6 tracking-tight">
      Gift Cards Emitidas Hoy
    </h3>

    {giftCards.length > 0 ? (
      <div className="overflow-x-auto border border-emerald-700 rounded-xl shadow-xl mb-10 bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800">
        <table className="min-w-full text-sm text-left text-gray-100">
          <thead className="text-xs uppercase bg-emerald-700 text-emerald-100 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-4 font-semibold tracking-wider">Seleccionar</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Código Público</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Valor Inicial</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Saldo Actual</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Estado</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Emitida</th>
              <th className="px-6 py-4 font-semibold tracking-wider">Expira</th>
            </tr>
          </thead>
          <tbody>
            {giftCards.map((gc, idx) => {
              const isSelected = selectedItems.has(gc.gift_card_id);
              const statusColor = gc.state === 'Activa'
                ? 'bg-emerald-500 text-white'
                : gc.state === 'Usada'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-400 text-gray-900';
              return (
                <tr
                  key={gc.gift_card_id}
                  className={`transition-colors duration-300 ${
                    idx % 2 === 0 ? 'bg-gray-800' : 'bg-gray-700'
                  } hover:bg-gray-600`}
                >
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleCheckboxChange(gc.gift_card_id)}
                      className="h-5 w-5 text-emerald-400 bg-gray-700 border-gray-600 rounded focus:ring-emerald-400 focus:ring-2"
                    />
                  </td>
                  <td className="px-6 py-4 font-mono text-teal-300">{gc.public_code}</td>
                  <td className="px-6 py-4 font-semibold text-emerald-400">${gc.initial_value}</td>
                  <td className="px-6 py-4 font-semibold text-teal-400">${gc.current_balance}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-block px-3 py-1 text-xs font-bold rounded-full shadow-sm ${statusColor}`}>
                      {gc.state}
                    </span>
                  </td>
                  <td className="px-6 py-4">{new Date(gc.issued_at).toLocaleString()}</td>
                  <td className="px-6 py-4">
                    {gc.expires_at
                      ? new Date(gc.expires_at).toLocaleDateString()
                      : <span className="italic text-gray-400">N/A</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="text-gray-400 italic mb-10 flex items-center space-x-2">
        <i className="fas fa-info-circle text-emerald-400"></i>
        <span>No hay gift cards emitidas hoy.</span>
      </div>
    )}
  </>
);

export default GiftCardsTable;
